<template>
<div div="menu-base-component">
  <li v-for="(property, i) in menuProperties" :key="i" :class="isDropdownClass(property)">
    <router-link
        v-if="!property.isDropdown"
        class="nav-link pre-formatted"
        data-placement="bottom"
        :title="property.title"
        :to="property.to"
    >{{ property.text }}</router-link>

    <div v-else>
      <a
          class="nav-link dropdown-toggle pre-formatted"
          href=""
          id="navbarDropdownPortfoliodes"
          data-toggle="dropdown"
          aria-haspopup="true"
          aria-expanded="false"
      >{{ property.text }}</a>
      <div class="dropdown-menu" aria-labelledby="navbarDropdownPortfoliodes">
        <router-link
            v-for="dropdownItem in property.dropdownProperties"
            class="dropdown-item pre-formatted"
            data-toggle="tooltip"
            data-placement="bottom"
            :title="dropdownItem.title"
            :to="dropdownItem.to"
        >{{ dropdownItem.text }}</router-link>
      </div>
    </div>

  </li>
</div>
</template>

<script>
export default {
  name: "MenuBaseComponent",
  methods: {
    isDropdownClass: function (property) {
      return 'nav-item ' + property.isDropdown ? 'dropdown' : ''
    }
  },
  props: {
    menuProperties: Object
  }
}
</script>

<style scoped>
  .pre-formatted {
    white-space: pre;
  }
</style>